import { render } from "./Sprechregeln.vue?vue&type=template&id=544975dc&scoped=true"
import script from "./Sprechregeln.vue?vue&type=script&lang=js"
export * from "./Sprechregeln.vue?vue&type=script&lang=js"

import "./Sprechregeln.vue?vue&type=style&index=0&id=544975dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544975dc"]])

export default __exports__